import i18n from '../plugins/i18n';
import { CURRENCY } from '../../utils/configure-environment';

export default amount =>
  new Intl.NumberFormat(i18n.locale.replace('_', '-'), {
    style: 'currency',
    currency: CURRENCY
  }).format(amount);
